import React from 'react';
import cn from 'classnames';

import type { TDesktop } from '../../models/desktop';
import type { TMobile } from '../../models/mobile';

import { countRatio } from './helpers';

/**
 * Функция отображения изображения основной версии баннера
 * @param props пропс виджета
 */

/**
 * TODO: Не удалять пока не поймём, что в новой версии MainBanner эта утилита будет не нужна.
 * ratio - костыль полифил для aspect-ratio. Тк здесь он работает относительно пропса,
 * то переписываем ту же логику в стайл
 * https://www.npmjs.com/package/postcss-aspect-ratio-polyfill
 */
export function bannerImage(props: TMobile | TDesktop) {
    const { Img, image, imageAltText, imageHeight, imageWidth, styles } = props;
    const ratio = countRatio(imageHeight, imageWidth);

    return image ? (
        <>
            {!!ratio && (
                <div
                    className={styles.aspectRatioLeft}
                    style={{
                        paddingTop: ratio ? `${ratio}%` : undefined,
                    }}
                />
            )}

            <Img
                alt={imageAltText}
                className={cn(styles.external, styles.responsiveImage)}
                src={image}
            />
            {!!ratio && <div className={styles.aspectRatioRight} />}
        </>
    ) : null;
}
